// Admin API client. Bearer JWT in localStorage.

function resolveBackendUrl(): string {
  const fromEnv = import.meta.env.VITE_BACKEND_URL;
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host.endsWith('godrop.sg')) return 'https://api.godrop.sg';
    if (host.endsWith('huper.technology')) return 'https://godrop-api.huper.technology';
  }
  return 'http://localhost:3000';
}

export const BACKEND_URL = resolveBackendUrl();
const TOKEN_KEY = 'godrop_admin_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t: string | null): void {
  if (t == null) localStorage.removeItem(TOKEN_KEY);
  else localStorage.setItem(TOKEN_KEY, t);
}

export class ApiError extends Error {
  constructor(public status: number, public body: unknown) {
    super(`api ${status}`);
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit & { json?: unknown } = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  const t = getToken();
  if (t) headers.set('Authorization', `Bearer ${t}`);
  let body = init.body;
  if (init.json !== undefined) {
    body = JSON.stringify(init.json);
    if (!headers.has('content-type')) headers.set('content-type', 'application/json');
  }
  const res = await fetch(`${BACKEND_URL}${path}`, { ...init, headers, body, credentials: 'include' });
  if (res.status === 204) return undefined as T;
  let payload: unknown;
  try {
    payload = await res.json();
  } catch {
    payload = null;
  }
  if (!res.ok) throw new ApiError(res.status, payload);
  return payload as T;
}
